import React from 'react'
import Layout from '../../components/layout/Layout'
import ContractsSupervised from './ContractsSupervised'
import UserProfileCard from '../../components/common/UserProfileCard'
import { useRecoilValue } from 'recoil'
import { userInfoState } from '../../recoil/atoms'

export default function SupervisorDashboard() {
  const userInfo = useRecoilValue(userInfoState)
  return (
    <Layout>
      <UserProfileCard
        title="مشخصات ناظر"
        name={userInfo?.name}
        code={userInfo?.meli_code || userInfo?.national_code}
        codeLabel="کد ملی ناظر"
        logo={userInfo?.logo}
      />
      <ContractsSupervised />
    </Layout>
  )
}
